import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MenubarModule, PanelMenuModule} from 'primeng/primeng';
import {MenuBarComponent} from './menu-bar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PanelMenuModule,
    MenubarModule
  ],
  declarations: [MenuBarComponent],
  exports: [MenuBarComponent]
})
export class MenuBarModule {
}
